import React from 'react';
import { Link } from 'react-router-dom';
import { profile } from './profile';
import { publications } from './publications';

// Edit the sections below directly. Items marked TODO are placeholders.
export default function CV() {
  return (
    <div className="page cv">
      <div className="cv-head">
        <h1 className="page-title">Curriculum Vitae</h1>
        {profile.cvPdf && (
          <a className="cv-download" href={profile.cvPdf} target="_blank" rel="noreferrer">Download PDF</a>
        )}
      </div>

      <section className="cv-section">
        <h2>Research interests</h2>
        <p>
          Model merging, mechanistic interpretability of vision–language models,
            robust and out-of-distribution generalization, representation learning.
        </p>
      </section>

      <section className="cv-section">
        <h2>Education</h2>
        <ul className="cv-list">
          <li><span className="cv-when">2026 - today</span> PhD, Machine Learning — <em>KTH Royal Institute of Technology, Stockholm</em> {/* TODO advisor / group */}</li>
          <li><span className="cv-when">2023 - 2026</span> MSc, Machine Learning — <em>University of Tübingen</em></li>
          <li><span className="cv-when">2019 - 2023</span> BSc, Computer Science — <em>Karlsruhe Institute of Technology</em></li>
        </ul>
      </section>

      <section className="cv-section">
        <h2>Publications</h2>
        <ul className="cv-list">
          {publications.map((p) => (
            <li key={p.id}>{p.authors.join(', ')}. <em>{p.title}</em>. {p.venue}{String(p.venue).includes(String(p.year)) ? '' : `, ${p.year}`}.</li>
          ))}
        </ul>
        <Link className="section-more" to="/publications">Full list →</Link>
      </section>

      <section className="cv-section">
        <h2>Experience</h2>
          <ul className="cv-list">
              <li><span className="cv-when">2024 - 2026</span> Research Assistant — Mathematical Methods in Computer
                  Science
              </li>
              <li><span className="cv-when">2022</span> Research Assistant — Fraunhofer IOSB, Karlsruhe
              </li>
          </ul>
      </section>


      <section className="cv-section">
        <h2>Contact</h2>
        <p>
          {profile.email && <a href={`mailto:${profile.email}`}>{profile.email}</a>}
          {profile.links.github && (
            <> · <a href={profile.links.github} target="_blank" rel="noreferrer">GitHub</a></>
          )}
        </p>
      </section>
    </div>
  );
}
